module.exports = __webpack_public_path__ + "static/images/drop-off-2.2ZTgi-4.svg";